import React, {useEffect, useState} from 'react';
import Loader from "../components/Loader";
import styled from "styled-components";
import SplashScreenCircleButton from "../components/SplashScreen/SplashScreenCircleButton";
import StreakCard from "../components/SplashScreen/StreakCard";
import {useAppDispatch, useAppSelector} from '../hooks/hooks'
import NotificationModal from "../components/NotificationModal";
import {initNotification} from "../store/notificationSlice";
import {fetchStrike, fetchUser} from "../store/userSlice";
import WebApp from "@twa-dev/sdk";
import {fetchSwipeState} from "../store/swipeSlice";
import router from "../router/router";
import ActionButton from "../components/Buttons/ActionButton";
import InfinityIcon from "../components/Images/InfinityIcon";
import SplashScreenLetters from "../components/SplashScreen/SplashScreenLetters";
import SplashScreenRings from "../components/SplashScreen/SplashScreenRings";

const safeTelegramData = WebApp.initData;
const referralData = WebApp.initDataUnsafe.start_param;

const RootSplashScreen: React.FC = () => {
    const dispatch = useAppDispatch();
    const {data: userData, status: userStatus, error: userError} = useAppSelector((state) => state.user);
    const {status: swipeStateStatus, error: swipeStateError} = useAppSelector((state) => state.swipe);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        switch (userStatus) {
            case 'idle':
                dispatch(fetchUser({data: safeTelegramData, invitation_code: referralData || ''}));
                break;
            case 'rejected':
                dispatch(initNotification({data: {message: userError, type:'error',show: true}}))
                break;
            case 'fulfilled':
                dispatch(fetchStrike());
                break;
            case 'fulfilled_strike':
                if (swipeStateStatus === 'idle') {
                    dispatch(fetchSwipeState());
                }
                if (swipeStateStatus === 'rejected') {
                    dispatch(initNotification({data: {message: swipeStateError, type: 'error', show: true}}))
                }
                if (swipeStateStatus === 'fulfilled') {
                    setLoading(false);
                }
                break;
            default:
                break;
        }
    }, [dispatch, userStatus, swipeStateStatus, userError, swipeStateError]);

    if(!loading && !userData.has_checked_tutorial) {
        router.navigate('/tutorial')
    }

    if(!loading && userData.has_checked_tutorial && !userData.points_awarded) {
        router.navigate('/main')
    }

    const clickHandler = () => {
        router.navigate('main')
    }

    return (
        <Container>
            <Loader loading={loading} duration={300}>
                <NotificationModal/>
                {!loading && userData.points_awarded &&
                    <Wrapper>
                        <AnimationWrapper>
                            <StreakCard days={userData.current_strike_length}/>
                            <SplashScreenCircleButton/>
                            <SplashScreenLetters/>
                            <SplashScreenRings/>
                        </AnimationWrapper>
                        <TextWrapper>
                            <div style={{textAlign: 'center', marginBottom: '32px'}}>
                                <P>You just earned:</P>
                                <Points>+{userData.points_awarded} <InfinityIcon width={12} height={28}/></Points>
                            </div>
                            <ActionButton width="calc(100% - 48px)" height="48px" type="active"
                                          clickHandler={clickHandler}>proceed</ActionButton>
                        </TextWrapper>
                    </Wrapper>
                }
            </Loader>
        </Container>
    );
}

export default RootSplashScreen;

const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
`;
const AnimationWrapper = styled.div`
    position: relative;
    width: 300px;
    height: 300px;
`;
const Container = styled.div`
    height: 100%;
    position: relative;
`;
const TextWrapper =styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
`
const P = styled.p`
    font-size: 16px;
    font-weight: 700;
    margin: 8px 0;
`;
const Points = styled.p`
    font-weight: 400;
    font-size: 48px;
    margin: 0;
    display: flex;
    align-items: center;
    column-gap: 8px;
`;
